import { render, staticRenderFns } from "./InnerTabsRenderer.vue?vue&type=template&id=34115826&"
import script from "./InnerTabsRenderer.vue?vue&type=script&lang=js&"
export * from "./InnerTabsRenderer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports